import { Link } from 'react-router-dom';

export default function LandingPage() {
  return (
    <div style={s.page}>
      <div style={s.bgGlow} />
      <div style={s.bgGrid} />

      {/* Nav */}
      <nav style={s.nav}>
        <div style={s.navInner}>
          <div style={s.navLeft}>
            <img src="/logo_256.png" alt="TM" style={s.navLogo} />
            <span style={s.navBrand}>Thankful Money</span>
          </div>
          <div style={s.navRight}>
            <Link to="/login" style={s.navLink}>Sign In</Link>
            <Link to="/register" style={s.navCta}>Get Access</Link>
          </div>
        </div>
      </nav>

      <div style={s.content}>
        {/* Hero */}
        <section style={s.hero}>
          {/* Animated floating orbs */}
          <div style={s.orbContainer}>
            <div style={{...s.orb, ...s.orb1}} />
            <div style={{...s.orb, ...s.orb2}} />
            <div style={{...s.orb, ...s.orb3}} />
          </div>

          <h1 style={s.heroTitle}>
            Institutional-grade signal intelligence.<br />
            <span style={s.heroAccent}>Built for individual investors.</span>
          </h1>
          <div style={s.heroBadge}>NOW IN PRIVATE BETA</div>

          {/* AI Core Animation */}
          <div style={s.aiCore}>
            <div style={s.aiRing1} />
            <div style={s.aiRing2} />
            <div style={s.aiRing3} />
            <div style={s.aiCenter}>
              <div style={s.aiPulse} />
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" style={{position:'relative',zIndex:2}}>
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="#10b981" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div style={s.aiLabel}>AI AGENT ACTIVE</div>
            <div style={s.aiSublabel}>Processing 1,247 symbols</div>
          </div>

          <p style={s.heroSub}>
            Our pipeline processes 1,000+ equities through 29 quantitative strategies and 17 technical indicators every trading day. An AI agent ranks opportunities. You get best in class signal intelligence, without the work.
          </p>
          <div style={s.heroActions}>
            <Link to="/register" style={s.btnPrimary}>Request Early Access</Link>
            <Link to="/login" style={s.btnGhost}>Sign In</Link>
          </div>
          <p style={s.heroNote}> Currently onboarding by invitation.</p>
        </section>

        {/* Metrics */}
        <section style={s.metrics}>
          <div style={s.metric}>
            <div style={s.metricValue}>1,247</div>
            <div style={s.metricLabel}>Symbols analyzed daily</div>
          </div>
          <div style={s.metricDivider} />
          <div style={s.metric}>
            <div style={s.metricValue}>29</div>
            <div style={s.metricLabel}>Quantitative strategies</div>
          </div>
          <div style={s.metricDivider} />
          <div style={s.metric}>
            <div style={s.metricValue}>64%</div>
            <div style={s.metricLabel}>Avg signal hit rate (5-day)</div>
          </div>
          <div style={s.metricDivider} />
          <div style={s.metric}>
            <div style={s.metricValue}>&lt;15 min</div>
            <div style={s.metricLabel}>Pipeline execution time</div>
          </div>
        </section>

        {/* Architecture section */}
        <section style={s.archSection}>
          <div style={s.archLabel}>THE PLATFORM</div>
          <h2 style={s.sectionTitle}>End-to-end, from market data to executed trade</h2>
          <p style={s.sectionSub}>
            A fully automated pipeline that ingests, computes, scores, and delivers so you spend time on decisions, not data wrangling.
          </p>
          <div style={s.archFlow}>
            <div style={s.archStep}>
              <div style={s.archStepIcon}>1</div>
              <div style={s.archStepTitle}>Ingest</div>
              <div style={s.archStepDesc}>Real-time price data for 1,000+ equities and ETFs via market data feeds</div>
            </div>
            <div style={s.archArrow}><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M5 12h14m-4-4l4 4-4 4" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></div>
            <div style={s.archStep}>
              <div style={s.archStepIcon}>2</div>
              <div style={s.archStepTitle}>Compute</div>
              <div style={s.archStepDesc}>17 indicators + 29 strategies scored across oscillators, MAs, and structure</div>
            </div>
            <div style={s.archArrow}><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M5 12h14m-4-4l4 4-4 4" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></div>
            <div style={s.archStep}>
              <div style={s.archStepIcon}>3</div>
              <div style={s.archStepTitle}>Rank</div>
              <div style={s.archStepDesc}>AI agent compares all signals, allocates capital to highest-conviction setups</div>
            </div>
            <div style={s.archArrow}><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M5 12h14m-4-4l4 4-4 4" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></div>
            <div style={s.archStep}>
              <div style={s.archStepIcon}>4</div>
              <div style={s.archStepTitle}>Execute</div>
              <div style={s.archStepDesc}>One-click trade execution through your connected brokerage account</div>
            </div>
          </div>
        </section>

        {/* Features grid */}
        <section style={s.featSection}>
          <div style={s.archLabel}>CAPABILITIES</div>
          <h2 style={s.sectionTitle}>What sets this apart</h2>
          <div style={s.featGrid}>
            <div style={s.featCard}>
              <div style={s.featCardHeader}>
                <div style={s.featDot} />
                <span style={s.featCardLabel}>Signal Engine</span>
              </div>
              <h3 style={s.featCardTitle}>Multi-factor scoring</h3>
              <p style={s.featCardDesc}>
                Every symbol receives a composite score from 5 independent categories: oscillators (11), moving averages (15), custom indicators (9), strategies (29), and crossover events (47+). No single indicator dominates.
              </p>
            </div>
            <div style={s.featCard}>
              <div style={s.featCardHeader}>
                <div style={s.featDot} />
                <span style={s.featCardLabel}>AI Agent</span>
              </div>
              <h3 style={s.featCardTitle}>Context-aware allocation</h3>
              <p style={s.featCardDesc}>
                The agent doesn't just pick the top score, it considers your existing positions, sector exposure, cash balance, and risk preferences to size each recommendation appropriately.
              </p>
            </div>
            <div style={s.featCard}>
              <div style={s.featCardHeader}>
                <div style={s.featDot} />
                <span style={s.featCardLabel}>Execution</span>
              </div>
              <h3 style={s.featCardTitle}>Brokerage-integrated</h3>
              <p style={s.featCardDesc}>
                Connected directly to your brokerage via OAuth. Review proposals, modify quantities, you approve, orders execute immediately. No manual entry, no delayed fills.
              </p>
            </div>
            <div style={s.featCard}>
              <div style={s.featCardHeader}>
                <div style={s.featDot} />
                <span style={s.featCardLabel}>Delivery</span>
              </div>
              <h3 style={s.featCardTitle}>Nightly proposals</h3>
              <p style={s.featCardDesc}>
                Personalized recommendations delivered every evening after market close. Review on the web, or reply to the email to approve. Your schedule, your pace.
              </p>
            </div>
            <div style={s.featCard}>
              <div style={s.featCardHeader}>
                <div style={s.featDot} />
                <span style={s.featCardLabel}>Analytics</span>
              </div>
              <h3 style={s.featCardTitle}>Signal performance tracking</h3>
              <p style={s.featCardDesc}>
                Every signal is tracked against actual 5-day forward returns. Strategy weights are continuously tuned based on measured hit rates, not backtested hypotheticals.
              </p>
            </div>
            <div style={s.featCard}>
              <div style={s.featCardHeader}>
                <div style={s.featDot} />
                <span style={s.featCardLabel}>Infrastructure</span>
              </div>
              <h3 style={s.featCardTitle}>Enterprise-grade pipeline</h3>
              <p style={s.featCardDesc}>
                Distributed compute on Databricks, Delta Lake storage on S3, Snowflake analytics warehouse, Airflow orchestration. The same stack hedge funds use, at individual scale.
              </p>
            </div>
          </div>
        </section>

        {/* Tech stack */}
        <section style={s.techSection}>
          <div style={s.archLabel}>POWERED BY</div>
          <h2 style={s.sectionTitle}>AI Agent Architecture</h2>
          <p style={s.sectionSub}>
            Built on AWS Bedrock AgentCore: a serverless AI runtime that orchestrates tool-calling agents with access to real-time market data, portfolio state, and quantitative signals.
          </p>
        </section>

        {/* Final CTA */}
        <section style={s.ctaSection}>
          <h2 style={s.ctaTitle}>Ready to see it in action?</h2>
          <p style={s.ctaText}>
            We're onboarding a limited number of users during private beta.
            Request access and we'll reach out when a spot opens.
          </p>
          <Link to="/register" style={s.btnPrimary}>Request Early Access</Link>
        </section>

        {/* Footer */}
        <footer style={s.footer}>
          <div style={s.footerTop}>
            <div style={s.footerBrand}>
              <img src="/logo_256.png" alt="TM" style={s.footerLogo} />
              <span style={s.footerBrandName}>Thankful Money</span>
            </div>
            <div style={s.footerLinks}>
              <Link to="/terms" style={s.footerLink}>Terms of Service</Link>
              <Link to="/privacy" style={s.footerLink}>Privacy Policy</Link>
              <Link to="/cybersecurity" style={s.footerLink}>Cybersecurity</Link>
              <Link to="/pricing" style={s.footerLink}>Pricing</Link>
            </div>
          </div>
          <div style={s.footerBottom}>
            <p style={s.copyright}>© 2026 Thankful Money Inc. All rights reserved.</p>
            <p style={s.disclaimer}>
              Thankful Money provides informational signal context only and does not provide investment advice.
              Past signal performance does not guarantee future results.
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
}

// Inject keyframe animations
if (typeof document !== 'undefined' && !document.getElementById('tm-landing-anims')) {
  const style = document.createElement('style');
  style.id = 'tm-landing-anims';
  style.textContent = `
    @keyframes tmFloat1 {
      0%, 100% { transform: translate(0, 0) scale(1); }
      33% { transform: translate(30px, -20px) scale(1.05); }
      66% { transform: translate(-20px, 15px) scale(0.95); }
    }
    @keyframes tmFloat2 {
      0%, 100% { transform: translate(0, 0) scale(1); }
      33% { transform: translate(-25px, 25px) scale(1.08); }
      66% { transform: translate(35px, -10px) scale(0.92); }
    }
    @keyframes tmFloat3 {
      0%, 100% { transform: translate(0, 0) scale(1); }
      50% { transform: translate(15px, -30px) scale(1.1); }
    }
    @keyframes tmPulseRing {
      0% { transform: translate(-50%, -50%) scale(0.8); opacity: 0.6; }
      50% { transform: translate(-50%, -50%) scale(1.2); opacity: 0.2; }
      100% { transform: translate(-50%, -50%) scale(0.8); opacity: 0.6; }
    }
    @keyframes tmPulseRing2 {
      0% { transform: translate(-50%, -50%) scale(1); opacity: 0.4; }
      50% { transform: translate(-50%, -50%) scale(1.4); opacity: 0.1; }
      100% { transform: translate(-50%, -50%) scale(1); opacity: 0.4; }
    }
    @keyframes tmPulseRing3 {
      0% { transform: translate(-50%, -50%) scale(1.1); opacity: 0.3; }
      50% { transform: translate(-50%, -50%) scale(1.6); opacity: 0.05; }
      100% { transform: translate(-50%, -50%) scale(1.1); opacity: 0.3; }
    }
    @keyframes tmCorePulse {
      0%, 100% { transform: scale(1); box-shadow: 0 0 20px rgba(16,185,129,0.3); }
      50% { transform: scale(1.05); box-shadow: 0 0 40px rgba(16,185,129,0.5); }
    }
    @keyframes tmScanLine {
      0% { top: 20%; opacity: 0; }
      10% { opacity: 1; }
      90% { opacity: 1; }
      100% { top: 80%; opacity: 0; }
    }
  `;
  document.head.appendChild(style);
}

const s = {
  page: { minHeight: '100vh', background: '#080d16', position: 'relative', overflow: 'hidden' },
  orbContainer: {
    position: 'absolute', top: '-60px', left: '50%', transform: 'translateX(-50%)',
    width: '700px', height: '400px', pointerEvents: 'none', zIndex: 0,
  },
  orb: {
    position: 'absolute', borderRadius: '50%', filter: 'blur(60px)',
  },
  orb1: {
    width: 300, height: 300, top: '10%', left: '15%',
    background: 'rgba(16,185,129,0.12)',
    animation: 'tmFloat1 8s ease-in-out infinite',
  },
  orb2: {
    width: 200, height: 200, top: '30%', right: '10%',
    background: 'rgba(59,130,246,0.08)',
    animation: 'tmFloat2 10s ease-in-out infinite',
  },
  orb3: {
    width: 150, height: 150, bottom: '10%', left: '40%',
    background: 'rgba(168,85,247,0.06)',
    animation: 'tmFloat3 12s ease-in-out infinite',
  },
  aiCore: {
    position: 'relative', width: 160, height: 160, margin: '0 auto 32px',
    display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column',
  },
  aiRing1: {
    position: 'absolute', top: '50%', left: '50%', width: 120, height: 120,
    borderRadius: '50%', border: '1px solid rgba(16,185,129,0.3)',
    animation: 'tmPulseRing 3s ease-in-out infinite',
  },
  aiRing2: {
    position: 'absolute', top: '50%', left: '50%', width: 120, height: 120,
    borderRadius: '50%', border: '1px solid rgba(16,185,129,0.2)',
    animation: 'tmPulseRing2 3s ease-in-out infinite 0.5s',
  },
  aiRing3: {
    position: 'absolute', top: '50%', left: '50%', width: 120, height: 120,
    borderRadius: '50%', border: '1px solid rgba(16,185,129,0.1)',
    animation: 'tmPulseRing3 3s ease-in-out infinite 1s',
  },
  aiCenter: {
    width: 64, height: 64, borderRadius: '50%',
    background: 'rgba(16,185,129,0.08)', border: '1px solid rgba(16,185,129,0.3)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    position: 'relative', zIndex: 2,
    animation: 'tmCorePulse 2s ease-in-out infinite',
  },
  aiPulse: {
    position: 'absolute', inset: -4, borderRadius: '50%',
    background: 'rgba(16,185,129,0.05)',
  },
  aiLabel: {
    fontSize: 10, fontWeight: 700, letterSpacing: 2, color: '#10b981',
    marginTop: 16, position: 'relative', zIndex: 2,
  },
  aiSublabel: {
    fontSize: 11, color: '#6b7280', marginTop: 4, position: 'relative', zIndex: 2,
  },
  bgGlow: {
    position: 'absolute', top: '-200px', left: '50%', transform: 'translateX(-50%)',
    width: '1200px', height: '600px',
    background: 'radial-gradient(ellipse at center, rgba(16,185,129,0.06) 0%, transparent 65%)',
    pointerEvents: 'none',
  },
  bgGrid: {
    position: 'absolute', inset: 0,
    backgroundImage: 'linear-gradient(rgba(255,255,255,0.015) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.015) 1px, transparent 1px)',
    backgroundSize: '80px 80px', pointerEvents: 'none',
  },
  nav: {
    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
    background: 'rgba(8,13,22,0.85)', backdropFilter: 'blur(12px)',
    borderBottom: '1px solid rgba(255,255,255,0.05)',
  },
  navInner: {
    maxWidth: 1080, margin: '0 auto', padding: '14px 32px',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  },
  navLeft: { display: 'flex', alignItems: 'center', gap: 10 },
  navLogo: { width: 28, height: 28, objectFit: 'contain' },
  navBrand: { fontSize: 15, fontWeight: 700, color: '#f9fafb', letterSpacing: 0.3 },
  navRight: { display: 'flex', alignItems: 'center', gap: 20 },
  navLink: { fontSize: 13, color: '#9ca3af', textDecoration: 'none', fontWeight: 500 },
  navCta: {
    fontSize: 13, fontWeight: 600, color: '#000', background: '#10b981',
    padding: '8px 18px', borderRadius: 6, textDecoration: 'none',
  },
  content: { position: 'relative', zIndex: 1, maxWidth: 1080, margin: '0 auto', padding: '0 32px' },
  hero: { textAlign: 'center', paddingTop: 140, paddingBottom: 80 },
  heroBadge: {
    display: 'inline-block', fontSize: 11, fontWeight: 600, letterSpacing: 1.8,
    color: '#10b981', background: 'rgba(16,185,129,0.08)', border: '1px solid rgba(16,185,129,0.2)',
    padding: '6px 18px', borderRadius: 20, marginBottom: 28,
  },
  heroTitle: { fontSize: 52, fontWeight: 800, color: '#f9fafb', lineHeight: 1.12, marginBottom: 24, letterSpacing: -1.5 },
  heroAccent: { color: '#10b981' },
  heroSub: { fontSize: 17, color: '#9ca3af', lineHeight: 1.7, maxWidth: 620, margin: '0 auto 40px' },
  heroActions: { display: 'flex', justifyContent: 'center', gap: 14 },
  btnPrimary: {
    padding: '14px 30px', background: '#10b981', color: '#000',
    borderRadius: 8, fontSize: 14, fontWeight: 700, textDecoration: 'none',
    boxShadow: '0 4px 24px rgba(16,185,129,0.25)',
  },
  btnGhost: {
    padding: '14px 30px', background: 'transparent', color: '#d1d5db',
    border: '1px solid #2d3748', borderRadius: 8, fontSize: 14, fontWeight: 600,
    textDecoration: 'none',
  },
  heroNote: { fontSize: 12, color: '#6b7280', marginTop: 16 },
  metrics: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'rgba(15,23,42,0.7)', border: '1px solid #1e293b',
    borderRadius: 14, padding: '28px 40px', marginBottom: 80, flexWrap: 'wrap',
    position: 'relative', overflow: 'hidden',
  },
  metric: { flex: 1, textAlign: 'center', minWidth: 140, padding: '8px 0' },
  metricValue: { fontSize: 28, fontWeight: 800, color: '#f9fafb', marginBottom: 4 },
  metricLabel: { fontSize: 12, color: '#6b7280', fontWeight: 500 },
  metricDivider: { width: 1, height: 44, background: '#1e293b' },
  archSection: { textAlign: 'center', marginBottom: 80 },
  archLabel: { fontSize: 11, fontWeight: 700, letterSpacing: 2, color: '#10b981', marginBottom: 12 },
  sectionTitle: { fontSize: 32, fontWeight: 800, color: '#f9fafb', marginBottom: 12, letterSpacing: -0.5 },
  sectionSub: { fontSize: 15, color: '#9ca3af', maxWidth: 560, margin: '0 auto 40px', lineHeight: 1.6 },
  archFlow: { display: 'flex', alignItems: 'stretch', justifyContent: 'center', gap: 8, overflowX: 'auto' },
  archStep: {
    flex: '0 0 200px', width: 200, background: 'rgba(15,23,42,0.7)',
    border: '1px solid #1e293b', borderRadius: 12, padding: '24px 18px', textAlign: 'left',
  },
  archStepIcon: {
    width: 28, height: 28, borderRadius: '50%', background: 'rgba(16,185,129,0.15)',
    color: '#10b981', fontSize: 12, fontWeight: 800,
    display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12,
  },
  archStepTitle: { fontSize: 14, fontWeight: 700, color: '#f9fafb', marginBottom: 6 },
  archStepDesc: { fontSize: 12, color: '#9ca3af', lineHeight: 1.5 },
  archArrow: { flexShrink: 0, display: 'flex', alignItems: 'center' },
  featSection: { textAlign: 'center', marginBottom: 80 },
  featGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 16, textAlign: 'left' },
  featCard: {
    background: 'rgba(15,23,42,0.5)', border: '1px solid #1e293b',
    borderRadius: 12, padding: '28px 24px',
  },
  featCardHeader: { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 },
  featDot: { width: 8, height: 8, borderRadius: '50%', background: '#10b981' },
  featCardLabel: { fontSize: 11, fontWeight: 600, color: '#6b7280', letterSpacing: 0.5, textTransform: 'uppercase' },
  featCardTitle: { fontSize: 16, fontWeight: 700, color: '#f9fafb', marginBottom: 8 },
  featCardDesc: { fontSize: 13, color: '#9ca3af', lineHeight: 1.6 },
  techSection: { textAlign: 'center', marginBottom: 80 },
  ctaSection: {
    textAlign: 'center', padding: '56px 40px', marginBottom: 60,
    background: 'rgba(16,185,129,0.03)', border: '1px solid rgba(16,185,129,0.12)',
    borderRadius: 16,
  },
  ctaTitle: { fontSize: 28, fontWeight: 800, color: '#f9fafb', marginBottom: 10 },
  ctaText: { fontSize: 14, color: '#9ca3af', marginBottom: 28, lineHeight: 1.6 },
  footer: { borderTop: '1px solid #1e293b', paddingTop: 32, paddingBottom: 40 },
  footerTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 16 },
  footerBrand: { display: 'flex', alignItems: 'center', gap: 8 },
  footerLogo: { width: 20, height: 20, objectFit: 'contain' },
  footerBrandName: { fontSize: 13, fontWeight: 600, color: '#9ca3af' },
  footerLinks: { display: 'flex', gap: 24, flexWrap: 'wrap' },
  footerLink: { fontSize: 12, color: '#6b7280', textDecoration: 'none' },
  footerBottom: { textAlign: 'center' },
  copyright: { fontSize: 11, color: '#4b5563', marginBottom: 6 },
  disclaimer: { fontSize: 11, color: '#374151', lineHeight: 1.5, maxWidth: 600, margin: '0 auto' },
};



